export default [
  {
    id: 1,
    crs: 'Porto Alegre',
    counties: [
      'Araricá',
      'Barão',
      'Brochier',
      'Cambará do Sul',
      'Campo Bom',
      'Canoas',
      'Capela de Santana',
      'Dois Irmãos',
      'Estância Velha',
      'Esteio',
      'Harmonia',
      'Igrejinha',
      'Ivoti',
      'Lindolfo Collor',
      'Maratá',
      'Montenegro',
      'Morro Reuter',
      'Nova Hartz',
      'Nova Santa Rita',
      'Novo Hamburgo',
      'Pareci Novo',
      'Parobé',
      'Portão',
      'Presidente Lucena',
      'Riozinho',
      'Rolante',
      'Salvador do Sul',
      'Santa Maria do Herval',
      'São Francisco de Paula',
      'São José do Hortêncio',
      'São José do Sul',
      'São Leopoldo',
      'São Pedro da Serra',
      'São Sebastião do Caí',
      'Sapiranga',
      'Sapucaia do Sul',
      'Tabaí',
      'Taquara',
      'Três Coroas',
      'Triunfo',
      'Tupandi',
    ],
    population: 1686231,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 2,
    crs: 'Porto Alegre',
    counties: [
      'Alvorada',
      'Arambaré',
      'Arroio dos Ratos',
      'Barão do Triunfo',
      'Barra do Ribeiro',
      'Butiá',
      'Cachoeirinha',
      'Camaquã',
      'Cerro Grande do Sul',
      'Charqueadas',
      'Chuvisca',
      'Dom Feliciano',
      'Eldorado do Sul',
      'General Câmara',
      'Glorinha',
      'Gravataí',
      'Guaíba',
      'Mariana Pimentel',
      'Minas do Leão',
      'Porto Alegre',
      'São Jerônimo',
      'Sentinela do Sul',
      'Sertão Santana',
      'Tapes',
      'Viamão',
    ],
    population: 2609412,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 3,
    crs: 'Pelotas',
    counties: [
      'Amaral Ferrador',
      'Arroio do Padre',
      'Arroio Grande',
      'Canguçu',
      'Capão do Leão',
      'Cerrito',
      'Chuí',
      'Cristal',
      'Herval',
      'Jaguarão',
      'Morro Redondo',
      'Pedras Altas',
      'Pedro Osório',
      'Pelotas',
      'Pinheiro Machado',
      'Piratini',
      'Rio Grande',
      'Santa Vitória do Palmar',
      'Santana da Boa Vista',
      'São José do Norte',
      'São Lourenço do Sul',
      'Turuçu',
    ],
    population: 845135,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 4,
    crs: 'Santa Maria',
    counties: [
      'Agudo',
      'Cacequi',
      'Capão do Cipó',
      'Dilermando de Aguiar',
      'Dona Francisca',
      'Faxinal do Soturno',
      'Formigueiro',
      'Itaara',
      'Itacurubi',
      'Ivorá',
      'Jaguari',
      'Jari',
      'Júlio de Castilhos',
      'Mata',
      'Nova Esperança do Sul',
      'Nova Palma',
      'Paraíso do Sul',
      'Pinhal Grande',
      'Quevedos',
      'Restinga Sêca',
      'Santa Maria',
      'Santiago',
      'São Francisco de Assis',
      'São João do Polêsine',
      'São Martinho da Serra',
      'São Pedro do Sul',
      'São Sepé',
      'São Vicente do Sul',
      'Silveira Martins',
      'Toropi',
      'Unistalda',
      'Vila Nova do Sul',
    ],
    population: 541247,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 5,
    crs: 'Caxias do Sul',
    counties: [
      'Alto Feliz',
      'Antônio Prado',
      'Bento Gonçalves',
      'Boa Vista do Sul',
      'Bom Jesus',
      'Bom Princípio',
      'Campestre da Serra',
      'Canela',
      'Carlos Barbosa',
      'Caxias do Sul',
      'Coronel Pilar',
      'Cotiporã',
      'Esmeralda',
      'Fagundes Varela',
      'Farroupilha',
      'Feliz',
      'Flores da Cunha',
      'Garibaldi',
      'Gramado',
      'Guabiju',
      'Guaporé',
      'Ipê',
      'Jaquirana',
      'Linha Nova',
      'Monte Alegre dos Campos',
      'Monte Belo do Sul',
      'Muitos Capões',
      'Nova Araçá',
      'Nova Bassano',
      'Nova Pádua',
      'Nova Petrópolis',
      'Nova Prata',
      'Nova Roma do Sul',
      'Paraí',
      'Picada Café',
      'Pinhal da Serra',
      'Pinto Bandeira',
      'Protásio Alves',
      'Santa Tereza',
      'São Jorge',
      'São José dos Ausentes',
      'São Marcos',
      'São Vendelino',
      'União da Serra',
      'Vacaria',
      'Vale Real',
      'Veranópolis',
      'Vila Flores',
      'Vista Alegre do Prata',
    ],
    population: 1079601,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 6,
    crs: 'Passo Fundo',
    counties: [
      'Água Santa',
      'Almirante Tamandaré do Sul',
      'Alto Alegre',
      'André da Rocha',
      'Arvorezinha',
      'Barracão',
      'Barros Cassal',
      'Cacique Doble',
      'Camargo',
      'Campos Borges',
      'Capão Bonito do Sul',
      'Carazinho',
      'Casca',
      'Caseiros',
      'Ciríaco',
      'Coqueiros do Sul',
      'Coxilha',
      'David Canabarro',
      'Ernestina',
      'Espumoso',
      'Fontoura Xavier',
      'Gentil',
      'Ibiaçá',
      'Ibiraiaras',
      'Ibirapuitã',
      'Itapuca',
      'Lagoa dos Três Cantos',
      'Lagoa Vermelha',
      'Lagoão',
      'Machadinho',
      'Marau',
      'Mato Castelhano',
      'Maximiliano de Almeida',
      'Montauri',
      'Mormaço',
      'Muliterno',
      'Não-Me-Toque',
      'Nicolau Vergueiro',
      'Nova Alvorada',
      'Paim Filho',
      'Passo Fundo',
      'Pontão',
      'Sananduva',
      'Santa Cecília do Sul',
      'Santo Antônio do Palma',
      'Santo Antônio do Planalto',
      'Santo Expedito do Sul',
      'São Domingos do Sul',
      'São João da Urtiga',
      'São José do Ouro',
      'Serafina Corrêa',
      'Sertão',
      'Soledade',
      'Tapejara',
      'Tapera',
      'Tio Hugo',
      'Tunas',
      'Tupanci do Sul',
      'Vanini',
      'Victor Graeff',
      'Vila Lângaro',
      'Vila Maria',
    ],
    population: 626126,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 7,
    crs: 'Bagé',
    counties: [
      'Aceguá',
      'Bagé',
      'Candiota',
      'Dom Pedrito',
      'Hulha Negra',
      'Lavras do Sul',
    ],
    population: 182579,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 8,
    crs: 'Cachoeira do Sul',
    counties: [
      'Arroio do Tigre',
      'Caçapava do Sul',
      'Cachoeira do Sul',
      'Cerro Branco',
      'Encruzilhada do Sul',
      'Estrela Velha',
      'Ibarama',
      'Lagoa Bonita do Sul',
      'Novo Cabrais',
      'Passa Sete',
      'Segredo',
      'Sobradinho',
    ],
    population: 200264,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 9,
    crs: 'Cruz Alta',
    counties: [
      'Boa Vista do Cadeado',
      'Boa Vista do Incra',
      'Colorado',
      'Cruz Alta',
      'Fortaleza dos Valos',
      'Ibirubá',
      'Jacuizinho',
      'Quinze de Novembro',
      'Saldanha Marinho',
      'Salto do Jacuí',
      'Santa Bárbara do Sul',
      'Selbach',
      'Tupanciretã',
    ],
    population: 152007,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 10,
    crs: 'Alegrete',
    counties: [
      'Alegrete',
      'Barra do Quaraí',
      'Itaqui',
      'Maçambará',
      'Manoel Viana',
      'Quaraí',
      'Rosário do Sul',
      'Santa Margarida do Sul',
      "Sant'Ana do Livramento",
      'São Gabriel',
      'Uruguaiana',
    ],
    population: 465038,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 11,
    crs: 'Erechim',
    counties: [
      'Aratiba',
      'Áurea',
      'Barão de Cotegipe',
      'Barra do Rio Azul',
      'Benjamin Constant do Sul',
      'Campinas do Sul',
      'Carlos Gomes',
      'Centenário',
      'Charrua',
      'Cruzaltense',
      'Entre Rios do Sul',
      'Erebango',
      'Erechim',
      'Erval Grande',
      'Estação',
      'Faxinalzinho',
      'Floriano Peixoto',
      'Gaurama',
      'Getúlio Vargas',
      'Ipiranga do Sul',
      'Itatiba do Sul',
      'Jacutinga',
      'Marcelino Ramos',
      'Mariano Moro',
      'Nonoai',
      'Paulo Bento',
      'Ponte Preta',
      'Quatro Irmãos',
      'Rio dos Índios',
      'São Valentim',
      'Severiano de Almeida',
      'Três Arroios',
      'Viadutos',
    ],
    population: 230814,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 12,
    crs: 'Santo Ângelo',
    counties: [
      'Bossoroca',
      'Caibaté',
      'Cerro Largo',
      'Dezesseis de Novembro',
      'Entre-Ijuís',
      'Eugênio de Castro',
      'Garruchos',
      'Guarani das Missões',
      'Mato Queimado',
      'Pirapó',
      'Porto Xavier',
      'Rolador',
      'Roque Gonzales',
      'Salvador das Missões',
      'Santo Ângelo',
      'Santo Antônio das Missões',
      'São Borja',
      'São Luiz Gonzaga',
      'São Miguel das Missões',
      'São Nicolau',
      'São Pedro do Butiá',
      'Sete de Setembro',
      'Ubiretama',
      'Vitória das Missões',
    ],
    population: 286248,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 13,
    crs: 'Santa Cruz do Sul',
    counties: [
      'Candelária',
      'Gramado Xavier',
      'Herveiras',
      'Mato Leitão',
      'Pantano Grande',
      'Passo do Sobrado',
      'Rio Pardo',
      'Santa Cruz do Sul',
      'Sinimbu',
      'Vale do Sol',
      'Vale Verde',
      'Venâncio Aires',
      'Vera Cruz',
    ],
    population: 327158,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 14,
    crs: 'Santa Rosa',
    counties: [
      'Alecrim',
      'Alegria',
      'Boa Vista do Buricá',
      'Campina das Missões',
      'Cândido Godói',
      'Doutor Maurício Cardoso',
      'Giruá',
      'Horizontina',
      'Independência',
      'Nova Candelária',
      'Novo Machado',
      'Porto Lucena',
      'Porto Mauá',
      'Porto Vera Cruz',
      'Santa Rosa',
      'Santo Cristo',
      'São José do Inhacorá',
      'São Paulo das Missões',
      'Senador Salgado Filho',
      'Três de Maio',
      'Tucunduva',
      'Tuparendi',
    ],
    population: 226933,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 15,
    crs: 'Palmeira das Missões',
    counties: [
      'Barra Funda',
      'Boa Vista das Missões',
      'Braga',
      'Cerro Grande',
      'Chapada',
      'Constantina',
      'Coronel Bicaco',
      'Dois Irmãos das Missões',
      'Engenho Velho',
      'Gramado dos Loureiros',
      'Jaboticaba',
      'Lajeado do Bugre',
      'Miraguaí',
      'Nova Boa Vista',
      'Novo Barreiro',
      'Novo Xingu',
      'Palmeira das Missões',
      'Redentora',
      'Ronda Alta',
      'Rondinha',
      'Sagrada Família',
      'São José das Missões',
      'São Pedro das Missões',
      'Sarandi',
      'Três Palmeiras',
      'Trindade do Sul',
    ],
    population: 161508,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 16,
    crs: 'Lajeado',
    counties: [
      'Anta Gorda',
      'Arroio do Meio',
      'Bom Retiro do Sul',
      'Boqueirão do Leão',
      'Canudos do Vale',
      'Capitão',
      'Colinas',
      'Coqueiro Baixo',
      'Cruzeiro do Sul',
      'Dois Lajeados',
      'Doutor Ricardo',
      'Encantado',
      'Estrela',
      'Fazenda Vilanova',
      'Forquetinha',
      'Ilópolis',
      'Imigrante',
      'Lajeado',
      'Marques de Souza',
      'Muçum',
      'Nova Bréscia',
      'Paverama',
      'Poço das Antas',
      'Pouso Novo',
      'Progresso',
      'Putinga',
      'Relvado',
      'Roca Sales',
      'Santa Clara do Sul',
      'São José do Herval',
      'São Valentim do Sul',
      'Sério',
      'Taquari',
      'Teutônia',
      'Travesseiro',
      'Vespasiano Corrêa',
      'Westfália',
    ],
    population: 325412,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 17,
    crs: 'Ijuí',
    counties: [
      'Ajuricaba',
      'Augusto Pestana',
      'Bozano',
      'Campo Novo',
      'Catuípe',
      'Chiapetta',
      'Condor',
      'Coronel Barros',
      'Crissiumal',
      'Humaitá',
      'Ijuí',
      'Inhacorá',
      'Jóia',
      'Nova Ramada',
      'Panambi',
      'Pejuçara',
      'Santo Augusto',
      'São Martinho',
      'São Valério do Sul',
      'Sede Nova',
    ],
    population: 222771,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 18,
    crs: 'Osório',
    counties: [
      'Arroio do Sal',
      'Balneário Pinhal',
      'Capão da Canoa',
      'Capivari do Sul',
      'Caraá',
      'Cidreira',
      'Dom Pedro de Alcântara',
      'Imbé',
      'Itati',
      'Mampituba',
      'Maquiné',
      'Morrinhos do Sul',
      'Mostardas',
      'Osório',
      'Palmares do Sul',
      'Santo Antônio da Patrulha',
      'Tavares',
      'Terra de Areia',
      'Torres',
      'Tramandaí',
      'Três Cachoeiras',
      'Três Forquilhas',
      'Xangri-lá',
    ],
    population: 341119,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
  {
    id: 19,
    crs: 'Frederico Westphalen',
    counties: [
      'Alpestre',
      'Ametista do Sul',
      'Barra do Guarita',
      'Bom Progresso',
      'Caiçara',
      'Cristal do Sul',
      'Derrubadas',
      'Erval Seco',
      'Esperança do Sul',
      'Frederico Westphalen',
      'Iraí',
      'Liberato Salzano',
      'Novo Tiradentes',
      'Palmitinho',
      'Pinhal',
      'Pinheirinho do Vale',
      'Planalto',
      'Rodeio Bonito',
      'Seberi',
      'Taquaruçu do Sul',
      'Tenente Portela',
      'Tiradentes do Sul',
      'Três Passos',
      'Vicente Dutra',
      'Vista Alegre',
      'Vista Gaúcha',
    ],
    population: 187063,
    census: 2010,
    state_name: 'Rio Grande do Sul',
  },
];
